import { render, staticRenderFns } from "./AltButton.vue?vue&type=template&id=70811094&scoped=true&"
import script from "./AltButton.vue?vue&type=script&lang=js&"
export * from "./AltButton.vue?vue&type=script&lang=js&"
import style0 from "./AltButton.vue?vue&type=style&index=0&id=70811094&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70811094",
  null
  
)

export default component.exports